import "chartjs-adapter-moment"

import { FunctionComponent, h } from "preact"

import Chart from "../../../components/chart"
import Container from "../../../parts/container"
import MillsTable from "../../../components/mills-table"
import Pagination from "../../../components/pagination"
import { SensorTypeQuery } from "../../../enum/sensor.enum"
import TopBar from "../../../components/topbar"
import TopFilter from "../../../components/TopFilter/overview"
import distinctSensor from "../../../utils/distinctSensor"
import moment from "moment"
import style from "./style.scss"
import useAlerts from "../../../hooks/useAlerts"
import useCems from "../../../hooks/useCems"
import { useEffect } from "preact/hooks"
import useMills from "../../../hooks/useMills"
import useObjectState from "../../../hooks/useObjectState"
import useOverview from "../../../hooks/useOverview"
import usePagination from "../../../hooks/usePagination"
import useRaw from "../../../hooks/useRaw"
import useTopFilter from "../../../hooks/useTopFilter"
import Renderif from "../../../components/Renderif";
import Loading from "../../../components/loading";

type DashboardOverviewPageProps = h.JSX.HTMLAttributes<HTMLDivElement>

const DashboardOverviewPage: FunctionComponent<DashboardOverviewPageProps> = () => {
  const topFilter = useTopFilter()
  const [filter, setFilter] = useObjectState({
    mil: "",
    cems: "",
    sensor: "",
  })
  const { data: mills } = useMills()
  const { data: cems } = useCems()
  const { data: chartData } = useRaw({
    type: SensorTypeQuery.overview,
    filter: topFilter.output,
  })
  
  console.log(topFilter.output)

  const { data: alerts, isLoading: isLoadingAlerts } = useAlerts(topFilter.output, filter.mil)

  const alertPagination = usePagination({
    count: alerts?.length || 0,
    step: 8,
  })
  const sensors = chartData ? distinctSensor(chartData) : []

  const { data: overviewData, isLoading: isLoadingOverview } = useOverview({
    ...topFilter.output,
  })
  useEffect(() => {
    if (sensors.length) setFilter({ sensor: sensors[0].name })
  }, [sensors.length])

  return (
    <div className="w-100">
      <TopBar title="SPARING" subtitle="Dashboard Overview">
        <TopFilter hook={topFilter} />
        <select
          className="w-auto form-select rounded-pill"
          onChange={({ currentTarget }) => setFilter({ mil: currentTarget.value, cems: "", sensor: "" })}
          value={filter.mil}
        >
          <option value="">All Mills</option>
          {mills?.map((mil) => (
            <option key={mil.uuid} value={mil.uuid}>
              {mil.name}
            </option>
          ))}
        </select>
      </TopBar>
      <Container>
        <div className="row align-items-stretch">
          <div className="col-xxl-8 col-12 mb-3">
            {/* All Parameters */}
            <div className="card">
              <div className="card-title">
                <h3>All Parameters</h3>
              </div>
              <div className="card-body">
                <div className={style.mills}>
                  <MillsTable overviewData={overviewData} activeMills={filter.mil} isLoading={isLoadingOverview} />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xxl-4 col-4 mb-3">
            <div className="card h-100">
              <div className="card-title">
                <h3>Alert Log</h3>
              </div>
              <div className="card-body overflow-auto d-flex flex-column justify-content-between h-100">
                <table className="table table-striped table-data table-center">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Alert</th>
                    </tr>
                  </thead>
                  <tbody>
                    <Renderif isTrue={isLoadingAlerts}>
                      <tr>
                        <td className="text-center" colSpan={2}>
                          <Loading />
                        </td>
                      </tr>
                    </Renderif>
                    {alerts?.length ? (
                      alerts
                        ?.filter((alert) => !filter.mil || alert?.mil?.uuid == filter.mil)
                        ?.slice(alertPagination.output, alertPagination.output + alertPagination.step)
                        .map((alert) => (
                          <tr className="small" key={alert.uuid}>
                            <td className={style.no_wrap}>{moment(alert.created_at).format("YYYY-MM-DD HH:mm")}</td>
                            <td>
                              {alert?.cem?.name ? alert?.cem?.name + ", " : ""}
                              {alert.description
                                .replace("sensor name", "")
                                .replace("lower_threshold", "")
                                .replace("upper_threshold", "")
                                .replace("value", "")
                                .replace(/\d+\.\d{2,}/g, (a) => Number(a).toFixed(2))
                                .replace(/\,\s*0$/g, "")}
                            </td>
                          </tr>
                        ))
                    ) : (
                      <tr>
                        <td className="text-center" colSpan={2}>
                          No Data
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="d-flex justify-content-center">
                  <Pagination hook={alertPagination} />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xxl-12 col-8 mb-3">
            <div className="card w-100">
              <div className="card-title">
                <h3></h3>
                <div class="d-flex flex-row">
                  
                  <select
                    value={filter.sensor}
                    onChange={({ currentTarget }) => setFilter({ sensor: currentTarget.value })}
                    className="w-auto form-select rounded-pill ms-2"
                  >
                    {sensors.map((sensor, idx) => (
                      <option key={sensor.name + idx} value={sensor.name}>
                        {sensor.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="card-body">
                {chartData && (
                  <Chart
                    height={120}
                    sensorName={filter.sensor}
                    cems={filter.cems}
                    mils={filter.mil}
                    chartData={chartData}
                  />

                )}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default DashboardOverviewPage
